import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useJournalsData(selectedCompanyId: number) {
    const { data: journals, isLoading: isLoadingJournals } = useQuery({
        queryKey: ['journals', selectedCompanyId],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.transactions.journals', selectedCompanyId));
            return data;
        },
        placeholderData: [],
    });

    return {
        journals,
        isLoadingJournals,
    };
}
